export default __webpack_public_path__ + "static/bg-finance--mobile-31c7d029643816a7752d185d3833ecdf.webp";